import { MedelyDateTime } from '@medely/date-time-tools';
import { yup } from '@medely/ui-kit';

type ValidateEndDateProps = {
  startDate: Date;
  endDate: Date;
};

export const validateEndDate = ({ startDate, endDate }: ValidateEndDateProps) => {
  if (!!endDate) {
    const parsedStartDate = new MedelyDateTime(new Date(startDate).toISOString(), { tz: 'system' });
    const parsedEndDate = new MedelyDateTime(new Date(endDate).toISOString(), { tz: 'system' });
    const today = new MedelyDateTime(new Date().toISOString(), { tz: 'system' });
    const isEndDateAfterStartDate = parsedEndDate.isAfter(parsedStartDate);
    const isEndDateInTheFuture = parsedEndDate.isBefore(today);

    if (!isEndDateAfterStartDate) {
      return 'End date must be after start date';
    }

    if (!isEndDateInTheFuture) {
      return 'End date cannot be in the future';
    }
  } else {
    return 'Required';
  }

  return undefined;
};

const validateEndDateField = () =>
  yup.date().test({
    name: 'valid-end-date',
    test(value, ctx) {
      const errorMessage = validateEndDate({
        endDate: ctx.parent.end_date,
        startDate: ctx.parent.start_date,
      });
      if (!!errorMessage) {
        return ctx.createError({ message: errorMessage });
      }
      return true;
    },
  });

export const workGapValidationSchema = yup.object().shape({
  start_date: yup.date().required('Required'),
  end_date: yup.date().required('Required').concat(validateEndDateField()),
  explanation: yup.string().required('Required'),
});
